import toast from 'react-hot-toast';
import {
	Colors,
} from 'utils/color/ColorPalette';
import Button, {
	ButtonColor,
} from 'components/button';
import Typography, {
	TypographyType,
} from '../../components/typography/karim/Typography';
import {
	MdOutlineClose,
} from 'react-icons/md';
import './toast.scss';
import {
	ToastPosition,
} from 'react-hot-toast/dist/core/types';

declare type ToastPositionCentered = 'center';
export type ToastPositions = ToastPosition | ToastPositionCentered;

const customToast = (type:string, title: any, subtitle: any, duration = 3000, position?: ToastPositions) => {
	// eslint-disable-next-line object-curly-newline
	const reactHotToastPosition = position && position === 'center' ? {} : {position: position};
	const overrideToastPosition = position && position === 'center' ? 'toast-custom-center' : '';

	toast.custom((t) => {
		return (
			<div className={`toast-custom-container ${type} app-content ${overrideToastPosition}`}>
				<Typography
					type={TypographyType.textBaseSemiBold}
					style={{
						textAlign: 'left',
					}}
				>{title}</Typography>
				<Typography
					type={TypographyType.textNormalRegular}
					style={{
						textAlign: 'left',
					}}
				>
					{subtitle}
				</Typography>
				<div className="toast-custom-close-button">
					<Button  color={ButtonColor.NONE} onClick={() => toast.remove(t.id)}>
						<MdOutlineClose size={20} color={Colors.blue.shades.b900.hex}/>
					</Button>
				</div>
			</div>
		);
	}, {
		...reactHotToastPosition,
		duration: duration,
	});
}

const newAppVersionToast = (onClick: (t: any) => void, duration = 30000) => {

	const decide = (id: any, isInstall: boolean): any => {
		toast.remove(id);
		onClick(isInstall);
	}

	toast.custom((t) => {
		return (
			<div className="toast-custom-container toast-custom-info app-content">
				<Typography
					type={TypographyType.textBaseSemiBold}
					style={{
						textAlign: 'left',
					}}
				>Ny versjon</Typography>
				<Typography
					type={TypographyType.textNormalRegular}
					style={{
						textAlign: 'left',
					}}
				>Det har kommet en ny versjon</Typography>
				<Button color={ButtonColor.PRIMARY} onClick={() => decide(t.id, true)}>Install</Button>
				<Button color={ButtonColor.SECONDARY} onClick={() => decide(t.id, false)}>Postpone</Button>

			</div>
		);
	}, {
		duration: duration,
	});
}

const toastInfo = (title: any, subtitle: any, duration = 3000, position?: ToastPositions) =>
	customToast('toast-custom-info', title, subtitle, duration, position);
const toastWarn = (title: any, subtitle: any, duration = 3000, position?: ToastPositions) =>
	customToast('toast-custom-warn', title, subtitle, duration, position);
const toastError = (title: any, subtitle: any, duration = 3000, position?: ToastPositions) =>
	customToast('toast-custom-error', title, subtitle, duration, position);
const toastSuccess = (title: any, subtitle: any, duration = 3000, position?: ToastPositions) =>
	customToast('toast-custom-success', title, subtitle, duration, position);
const toastAction = (title: any, subtitle: any, duration = 3000, position: ToastPositions) =>
	customToast('toast-custom-action', title, subtitle, duration, position);

export {
	toastInfo,
	toastWarn,
	toastError,
	toastSuccess,
	toastAction,
	newAppVersionToast,
}